import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { MeasurementFilter } from 'schemas/MeasurementFilterSchema'
import MeasurementType from 'enums/MeasurementType'
import { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import { resolveValueFromMetric } from '../utils/surveyScoresUtil'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.surveyScores === undefined || widgetSetting.surveyScores === null

const isOverMaxInput = () => false

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  surveyScores: [
    ...(widgetSetting.surveyScores || []),
    {
      type: MeasurementType.SURVEY,
      overallChecked: true,
      values: resolveValueFromMetric(insights[0].name! as MetricCategoryItemStrings)
    } as MeasurementFilter
  ]
})

const generateSurveyScoresStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateSurveyScoresStrategy
